import { OFFER_DOCUMENT_UPLOAD_STATUSES } from 'cpool-constants';
import { z } from 'zod';

export const schemaRecordedDocumentsEuropaceUploadSuccess = z.object({
    uploadedAt: z.number(),
    uploadStatus: z.literal(OFFER_DOCUMENT_UPLOAD_STATUSES.SUCCESS),
});

export const schemaRecordedDocumentsEuropaceUploadPending = z.object({
    uploadStatus: z.literal(OFFER_DOCUMENT_UPLOAD_STATUSES.PENDING),
});

export const schemaRecordedDocumentsEuropaceUploadFailed = z.object({
    uploadStatus: z.literal(OFFER_DOCUMENT_UPLOAD_STATUSES.FAILED),
});

export const schemaRecordedDocumentsEuropaceUploadNotRequested = z.object({
    uploadStatus: z.null(),
});
